import { Link, useLocation } from 'react-router-dom';
import { useSeo } from '@/hooks/useSeo';

export default function NotFound() {
  const location = useLocation();

  useSeo({
    title: '页面走丢了｜夜半瓜社',
    description: '这个地址没有对应的内容，可能是链接写错了，也可能条目已经被合并。回到瓜田情报库继续逛吧。',
    keywords: '夜半瓜社,页面不存在,瓜田情报库',
    path: location.pathname,
  });

  return (
    <main className="relative flex min-h-[80vh] flex-col items-center justify-center px-4 py-24 text-center">
      <span className="font-display text-[96px] leading-none tracking-wide text-background-200 md:text-[160px]">
        404
      </span>
      <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
        这条路径没有对应的内容
      </h1>
      <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600">
        可能是链接写错了，也可能是这条条目已经被合并进更新的一条。夜里迷路很正常，回情报库看看就好。
      </p>
      <p className="mt-2 font-label text-xs text-foreground-500">{location.pathname}</p>

      <div className="mt-8 flex flex-col gap-3 sm:flex-row">
        <Link
          to="/"
          className="inline-flex h-11 items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 font-label text-sm text-white transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-4-line" />
          回到首页
        </Link>
        <Link
          to="/feed"
          className="inline-flex h-11 items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-5 font-label text-sm text-foreground-900 transition-colors hover:border-accent-400 hover:text-accent-300"
        >
          <i className="ri-search-line" />
          去瓜田情报库
        </Link>
      </div>
    </main>
  );
}